import {$http} from '@/utils/https'

import {
    CHANGE_POPUP_REGISTER,
    CHANGE_POPUP_LOGIN,
    CHANGE_POPUP_PASSWORD_RECOVERY,
    CHANGE_POPUP_PASSWORD_EMAIL,
    CHANGE_POPUP_REGISTER_SUCCESS,
    CHANGE_POPUP_USER_EXIT,
    REMOVE_TOKEN,
    SET_TOKEN,
    EMAIL_SENT,
    CHANGE_POPUP_NEW_PASSWORD,
    CHANGE_POPUP_PASSWORD_SUCCESS,
    SET_LOADING_RESET_PASSWORD,
    SET_LOGIN_DATA,
    SET_RESTORE_PASSWORD,
    SET_LOADING_RESTORE_PASSWORD,
    DELETE_PRODUCTS,
    SHOW_CHANGE_PASSWORD_POPUP,
    SET_LOADING_LOGIN
} from '../mutation-types';
import {
    REGISTRATION,
    LOGIN,
    LOGOUT,
    RESET_PASSWORD,
    RESTORE_PASSWORD, NEW_PASSWORD
} from '../action-types';


const state = {
    showPopUpRegister: false,
    showPopUpLogin: false,
    showPopUpPasswordRecovery: false,
    showPopUpPasswordEmail: false,
    showPopUpRegisterSuccess: false,
    showPopUpUserExit: false,
    isAuthenticated: false,
    emailSent: '',
    showPopUpNewPassword: true,
    showPopUpNewPasswordSuccess: false,
    resetPassword: false,
    loginData: '',
    restorePasswordData: '',
    restorePassword: false,
    changePasswordPopup: false,
    loadingLogin: false
};
const actions = {
    [NEW_PASSWORD]: async ({commit}, payload) => {

        try {
            const result = await $http.post('v1/auth/password/restore', payload);
            // commit(SET_RESTORE_PASSWORD, result.data.data);
            // commit(SET_LOADING_RESTORE_PASSWORD, true)
        } catch (e) {
            throw e;
            // commit(SET_LOADING_RESTORE_PASSWORD, false)
        } finally {

        }
    },
    [RESTORE_PASSWORD]: async ({commit}, restorePassword) => {

        try {
            const result = await $http.post('v1/auth/password/change', restorePassword);
            commit(SET_RESTORE_PASSWORD, result.data.data);
            commit(SET_LOADING_RESTORE_PASSWORD, true)
        } catch (e) {
            throw e;
            commit(SET_LOADING_RESTORE_PASSWORD, false)
        } finally {

        }
    },
    [RESET_PASSWORD]: async ({commit}, payload) => {

        try {
            const result = await $http.post('v1/auth/password/reset', payload);
            commit(EMAIL_SENT, result.data.data);
            commit(SET_LOADING_RESET_PASSWORD, false)
        } catch (e) {
            throw e;

        } finally {

        }
    },
    [LOGOUT]: async ({commit}) => {
        try {
            // globalLoader(true);
            return await $http.post('v1/auth/logout');
        } catch (e) {
            throw e;
        } finally {
            commit(REMOVE_TOKEN);
        }
    },
    [REGISTRATION]: async ({commit}, payload) => {
        try {
            // commit(SET_LOADING_REGISTRATION, true);

            const result = await $http.post('v1/auth/register', payload);

            commit(SET_TOKEN, result.data.data.accessToken);
            commit(SET_LOGIN_DATA, result.message)
        } catch (e) {
            throw e;
        } finally {
            //commit(EMAIL_SENT, false); commit(SET_LOADING_REGISTRATION, false);
        }
    },
    [LOGIN]: async ({commit}, payload) => {
        try {
            commit(SET_LOADING_LOGIN, true);
            const result = await $http.post('v1/auth/login', payload);

            commit(SET_TOKEN, result.data.data.accessToken);

        } catch (e) {
            throw e;
            commit(SET_LOADING_LOGIN, false);
        } finally {
            commit(SET_LOADING_LOGIN, false);
        }
    },
}

const getters = {
    showPopUpRegister: state => state.showPopUpRegister,
    showPopUpLogin: state => state.showPopUpLogin,
    showPopUpPasswordRecovery: state => state.showPopUpPasswordRecovery,
    showPopUpPasswordEmail: state => state.showPopUpPasswordEmail,
    showPopUpRegisterSuccess: state => state.showPopUpRegisterSuccess,
    showPopUpUserExit: state => state.showPopUpUserExit,
    isAuthenticated: state => state.isAuthenticated,
    emailSent: state => state.emailSent,
    showPopUpNewPassword: state => state.showPopUpNewPassword,
    showPopUpNewPasswordSuccess: state => state.showPopUpNewPasswordSuccess,
    resetPassword: state => state.resetPassword,
    loginData: state => state.loginData,
    restorePasswordData: state => state.restorePasswordData,
    restorePassword: state => state.restorePassword,
    changePasswordPopup: state => state.changePasswordPopup,
    loadingLogin: state => state.loadingLogin
};

const mutations = {
    [DELETE_PRODUCTS]() {
        localStorage.removeItem('products');
        location.href = location.href;
    },
    [SET_RESTORE_PASSWORD](state, list) {
        state.restorePasswordData = list
    },
    [SET_LOGIN_DATA](state, list) {
        state.loginData = list
    },
    [SET_LOADING_RESET_PASSWORD](state, status) {
        state.resetPassword = status
    },
    [SET_LOADING_LOGIN](state, status) {
        state.loadingLogin = status
    },
    [SET_LOADING_RESTORE_PASSWORD](state, status) {
        state.restorePassword = status
    },
    [CHANGE_POPUP_REGISTER](state, status) {
        state.showPopUpRegister = status
    },
    [SHOW_CHANGE_PASSWORD_POPUP](state, status) {
        state.changePasswordPopup = status
    },
    [CHANGE_POPUP_LOGIN](state, status) {
        state.showPopUpLogin = status
    },
    [CHANGE_POPUP_PASSWORD_RECOVERY](state, status) {
        state.showPopUpPasswordRecovery = status
    },
    [CHANGE_POPUP_PASSWORD_EMAIL](state, status) {
        state.showPopUpPasswordEmail = status
    },
    [CHANGE_POPUP_REGISTER_SUCCESS](state, status) {
        state.showPopUpRegisterSuccess = status
    },
    [CHANGE_POPUP_USER_EXIT](state, status) {
        state.showPopUpUserExit = status
    },
    [SET_TOKEN](state, token) {
        localStorage.setItem('user_token', token);
        state.isAuthenticated = true;
    },
    [REMOVE_TOKEN](state) {
        localStorage.removeItem('user_token');
        // localStorage.removeItem('products');
        state.isAuthenticated = false
        location.href = location.href;
    },
    [EMAIL_SENT](state, list) {
        state.emailSent = list
    },
    [CHANGE_POPUP_NEW_PASSWORD](state, status) {
        state.showPopUpNewPassword = status
    },
    [CHANGE_POPUP_PASSWORD_SUCCESS](state, status) {
        state.showPopUpNewPasswordSuccess = status
    }

};
export default {
    state,
    getters,
    actions,
    mutations,
}
